import moment from "moment";

/**
 * Những phép định dạng và bóc dữ liệu mà mọi trang giải của front office đều cần.
 *
 * Chuyển từ swiss/api.ts và swiss/live.tsx sang đây, KHÔNG sửa một dòng logic nào:
 * đây là một lần di chuyển, không phải một lần viết lại.
 */

/**
 * Tiền thưởng do ban tổ chức nhập TỰ DO, nên có thể là chuỗi kiểu Việt Nam
 * ("15.000.000", "10.000.000 đ"). Bóc mọi ký tự không phải số rồi mới Number, tránh
 * NaN do dấu chấm, dấu phẩy hay đơn vị.
 */
export const money = (value: number | string | null) => {
  if (value === null || value === undefined || value === "") return "—";
  const n = Number(String(value).replace(/[^\d]/g, ""));
  return Number.isNaN(n) ? "—" : n.toLocaleString("vi-VN");
};

/** Khoảng ngày dạng "12/10 – 20/10", hoặc một đầu khi thiếu đầu kia. */
export const dateRange = (from: any, to: any): string => {
  const a = from ? moment(from) : null;
  const b = to ? moment(to) : null;
  if (a?.isValid() && b?.isValid()) return `${a.format("DD/MM")} – ${b.format("DD/MM")}`;
  if (a?.isValid()) return a.format("DD/MM");
  if (b?.isValid()) return b.format("DD/MM");
  return "—";
};

/** Tên địa điểm viết tắt để nhồi vào ô hẹp. */
export const shortName = (name: string): string => {
  const parts = name.trim().split(/\s+/);
  if (parts.length <= 1) return name.slice(0, 10);
  return parts
    .slice(0, 2)
    .map((part) => part[0]?.toUpperCase() ?? "")
    .join("");
};

/**
 * Backend bọc phản hồi trong `{data: ...}`.
 *
 * Không bóc thì `.map` ném TypeError và cả trang báo lỗi KHÔNG kèm mã HTTP nào - gỡ
 * lỗi kiểu đó mất cả buổi vì nhìn như lỗi mạng.
 */
export const unwrap = (rsp: any) => (rsp && typeof rsp === "object" && "data" in rsp ? rsp.data : rsp);

/** Dữ liệu hỏng hoặc thiếu coi như rỗng, để `.map` không ném lỗi. */
export const asArray = (value: any): any[] => (Array.isArray(value) ? value : []);
